import { eSortMode, IColumn, ICondition, IExpression } from "./DataTable";

export const removeAccents = (str: string) => {
    if (!str) return str;
    return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, "d")
        .replace(/Đ/g, "D");
}
export const dynamicSort = (property: string, mode: eSortMode) => {
    var sortOrder = 1;
    if (mode === eSortMode.ASC) {
        sortOrder = 1;
    } else {
        sortOrder = -1;
    }
    return function (a: any, b: any) {
        var result =
            a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
    };
}
export const handleSearch = (columns: IColumn[], data: any[], key: string): any[] => {
    const normalizedKey = removeAccents(key.toLowerCase());
    const searchableColumns = columns.filter(col => col.dataField);
    return data.filter(item =>
        searchableColumns.some(col => {
            const value = col.filterValue ? col.filterValue(item) : item[`${col.dataField}`];
            return value &&
                removeAccents(value.toString().toLowerCase())
                    .includes(normalizedKey);
        })
    );
};
export const handleFilter = (conditions: ICondition[], data: any[], logicOperator: string, getValue: (field: string, item: any) => any = (field, item) => item[field]): any[] => {
    const filterExpression = conditions.map((cond: any) => [cond.field, cond.operator, cond.value])
        .reduce((acc: any, curr: any, i: any) => (i > 0 ? [...acc, logicOperator, curr] : [curr]), []);
    return data.filter((item) => {
        let result = true;
        let currentOperator = "and";

        for (let i = 0; i < filterExpression.length; i++) {
            const expr = filterExpression[i];
            if (typeof expr === "string") {
                currentOperator = expr;
                continue;
            }
            const [field, operator, value]: IExpression = expr;
            const itemValue = getValue(field, item);

            let conditionResult;
            switch (operator) {
                case "equals":
                    conditionResult = itemValue === value;
                    break;
                case "contains":
                    conditionResult = String(itemValue).toLowerCase().includes(String(value).toLowerCase());
                    break;
                case "greaterThan":
                    conditionResult = Number(itemValue) > Number(value);
                    break;
                case "lessThan":
                    conditionResult = Number(itemValue) < Number(value);
                    break;
                case "greaterThanOrEqual":
                    conditionResult = Number(itemValue) >= Number(value);
                    break;
                case "lessThanOrEqual":
                    conditionResult = Number(itemValue) <= Number(value);
                    break;
                default:
                    conditionResult = true;
            }
            result = currentOperator === "and" ? result && conditionResult : result || conditionResult;
        }
        return result;
    });
};